const NAV_ITEM_PROPERTIES = {
    admin: [
        {path: '/calendar', name: 'Kalendarz', key: 2, className: 'far fa-calendar-alt navbar-button-icon'},
        {path: '/myEvent', name: 'Moje urlopy', key: 2, className: 'fas fa-user-clock navbar-button-icon'},
        {path: '/table', name: 'Terminarz zespołu', key: 2, className: 'fas fa-clock navbar-button-icon'}
    ],
    manager: [
        {path: '/calendar', name: 'Kalendarz', key: 2, className: 'far fa-calendar-alt navbar-button-icon'},
        {path: '/myEvent', name: 'Moje urlopy', key: 2, className: 'fas fa-user-clock navbar-button-icon'},
        {path: '/table', name: 'Terminarz zespołu', key: 2, className: 'fas fa-clock navbar-button-icon'}
    ],
    user: [
        {path: '/calendar', name: 'Kalendarz', key: 2, className: 'far fa-calendar-alt navbar-button-icon'},
        {path: '/myEvent', name: 'Moje urlopy', key: 2, className: 'fas fa-user-clock navbar-button-icon'},
        {path: '/userTable', name: 'Terminarz zespołu', key: 2, className: 'fas fa-clock navbar-button-icon'}
    ],
    logout: {path: '/logout', name: 'Wyloguj', key: 3, className: 'fas fa-sign-out-alt navbar-button-icon'},
    profile: {path: '/home', name: 'Profil', key: 4, className: 'fas fa-user navbar-button-icon'},
    adminPanel: {path: '/panel', name: 'Panel administracyjny', key: 5, className: 'fa fa-cog navbar-button-icon'},
    login: {path: '/', name: 'Zaloguj', key: 6, className: 'fas fa-sign-in-alt login-title-icon'},
    fromModal: {key: 7},
    dropdown: [
        {path: '/employeelist', name: 'Lista pracowników', key: 2, className: 'fa fa-list-ul navbar-button-icon'},
        {path: '/teams', name: 'Zespoły', key: 2, className: 'fas fa-users navbar-button-icon'}
    ]

};

export default NAV_ITEM_PROPERTIES;


// WEBPACK FOOTER //
// ./src/constantValues/NAV_ITEM_PROPERTIES.js